/** API money and quantities arrive as decimal strings; anything unparseable counts as 0. */
export function numberValue(value: string | number | null | undefined) {
  const parsed = Number(value ?? 0)
  return Number.isFinite(parsed) ? parsed : 0
}

/** A typed quote quantity is a whole number of 1 or more; we never sell part of a unit (USA-1280). */
export function isWholeQuantity(text: string) {
  return /^\d+$/.test(text.trim()) && Number(text) >= 1
}
